import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LoadingService } from 'axis-components/components/loading/loading.service';
import { GmdService } from '../../services/gmd.service';

@Component({
  selector: 'app-gmd-information',
  templateUrl: './gmd-information.component.html',
  styleUrls: ['./gmd-information.component.scss']
})
export class GmdInformationComponent implements OnInit {
  @Input() selectedCompanyId;
  @Output() save = new EventEmitter();
  // @Output() saveCompany = new EventEmitter();
  companyType = [
    { id: '1', name: 'Affiliated' },
    { id: '2', name: 'Claims Only' },
    { id: '3', name: 'Fronting' },
    { id: '4', name: 'General Agent' },
    { id: '5', name: 'Joint Venture' },
    { id: '6', name: 'Subsidiary' },
    { id: '7', name: 'TPA' },
    { id: '8', name: 'Survey Agent'}
  ];
  leftSidebarClosed: Boolean = false;
  navPanel: Boolean = false;
  numericPercent;
  panel: string = '';
  touch;
  panelShow = this.panel;
  public companyForm: FormGroup;
  public showFlag = true;
  public dropdownTemplate: any;
  public toggleValue = true;
  public readOnly;
  constructor(private changeDetectorRef: ChangeDetectorRef, private fb: FormBuilder, private gmdservice: GmdService, private router: Router, public loadingService: LoadingService) { }

  trackByIndex(index: number): number {
    return index;
  }
  /* lifecycle hooks */
  ngAfterContentChecked(): void {
    this.getThemeMsg();
  }
  delete(): void {
    const req = {
      companyId: sessionStorage.getItem('selectedCompanyId')
    }
    this.gmdservice.deleteCompany(req).subscribe((obs: any)=> {
      if (obs.message || obs.Message) {
        this.gmdservice.notificationMessage.next("Company details deleted successfully!");
        this.router.navigateByUrl('/gmd/dashboard-gmd-sorting')
      }
    });
  }
  stopProp(event) {
    event.stopPropagation();
  }
  ngOnInit() {
    this.readOnly = sessionStorage.getItem('isReadOnly');
    this.goTop();
    if (sessionStorage.getItem('selectedCompanyId') && sessionStorage.getItem('selectedCompanyId') !== 'undefined') {
      this.selectedCompanyId = sessionStorage.getItem('selectedCompanyId');
      this.loadingService.start();
    }
    this.companyForm = this.fb.group({
      companyName: ['', [Validators.maxLength(50)]],
      status: 'Y',
      companyType: ['', [Validators.maxLength(50)]]
    });
    const req = {
      companyId: this.selectedCompanyId && this.selectedCompanyId !== "" ? this.selectedCompanyId : ""
    }
    if (this.selectedCompanyId && this.selectedCompanyId !== "") {
      this.gmdservice.getCompany(req).subscribe((obs: any)=> {
        if (obs) {
          this.loadingService.stop();
          this.companyForm.get('companyName').setValue(obs.companyName.trim());
          this.companyForm.get('status').setValue(obs.status);
          this.showFlag = obs.status === 'Y' ? true : false;
          this.patchFormValue();
          if (obs.companyType !== " ") {
            this.companyForm.get('companyType').setValue(obs.companyType);
          }
          this.header();
        }
      })
    }
    
  }
  toggleSelection() {
    this.showFlag = !this.showFlag;
    this.companyForm.get('status').setValue(this.showFlag ? 'Y' : 'N');
    this.patchFormValue();
  }
  patchFormValue() {
    if (this.companyForm.get('status').value === 'Y') {
      this.toggleValue = true;
    }
    if (this.companyForm.get('status').value === 'N') {
      this.toggleValue = false;
    }
  }
  /* methods */
  goTop() {  // reset the page when changing route
    window.scrollTo(0, 0);
  }

  getThemeMsg() {
    // if (this.storageService.get('theme') === 'axis-internal') {
    //   this.externalThemeFlag = false;
    // } else {
    //   this.externalThemeFlag = true;
    // }
  }

  highlightSection(section?: any) {
    // this.conditionService.setCondition('sectionHighlighted', section);
  }

  setCondition(type: any) {
    if (type === 'sectionHighlighted') {
      // this.sectionHighlighted = this.conditionService.conditionSetting()[type];
    }
    if (type === 'panelShow') {
      // this.panelShow = this.conditionService.conditionSetting()[type];
    }
  }
  setPanel(type: string): void {
    this.panelShow = type;
    // this.conditionService.setCondition('panelShow', type);
    // this.conditionService.setCondition('sectionHighlighted', type);
    this.changeDetectorRef.detectChanges();
  }
  header() {
    if (this.companyForm) {
      this.gmdservice.headerCompanyName.next(this.companyForm.get('companyName').value);
      this.gmdservice.headerCompanyType.next(this.companyForm.get('companyType').value.name || this.companyForm.get('companyType').value);
    }
  }
  public saveCompany(form: FormGroup): void {
    this.gmdservice.saveCompany({
        "companyId": this.selectedCompanyId && this.selectedCompanyId !== "" ? Number(this.selectedCompanyId) : "",
        "companyName": this.companyForm.value.companyName,
        "status": this.companyForm.value.status,
        "companyType": this.companyForm.value.companyType.name || this.companyForm.value.companyType
       }).subscribe((obs: any) => {
          // this.gmdservice.notificationMessage.next("Company details saved successfully!");
          if (obs.companyId && obs.companyId !== 'undefined') {
            sessionStorage.setItem('selectedCompanyId', obs.companyId);
          }
          this.selectedCompanyId = obs.companyId;
          sessionStorage.setItem('selectedCompanyId', obs.companyId);
          const req = {
            companyId: obs.companyId
          };
          this.gmdservice.getCompany(req).subscribe((res: any)=> {
            if (res && res.length > 0) {
              this.companyForm.get('companyName').setValue(res[0].companyName);
              this.companyForm.get('status').setValue(res[0].status);
              this.showFlag = res[0].status === 'Y' ? true : false;
              if (res[0].companyType !== " ") {
                this.companyForm.get('companyType').setValue(res[0].companyType);
              }
              this.header();
            }
          })
        });
  }
}
